import { render, staticRenderFns } from "./PressPost.vue?vue&type=template&id=021ebc38"
import script from "./PressPost.vue?vue&type=script&lang=js"
export * from "./PressPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports